import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var ForgetpassChangeSlice = createSlice({
    name: "ForgetpassChange",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _ForgetpassChangeSlice_actions = ForgetpassChangeSlice.actions;
export var fetchData = _ForgetpassChangeSlice_actions.fetchData, fetchDataSuccess = _ForgetpassChangeSlice_actions.fetchDataSuccess, fetchDataFailure = _ForgetpassChangeSlice_actions.fetchDataFailure, resetState = _ForgetpassChangeSlice_actions.resetState;
export default ForgetpassChangeSlice.reducer;
